"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _MainButton = _interopRequireDefault(require("../../../../Shared/Components/MainButton"));
var _AnalyticsWrapper = _interopRequireDefault(require("../Analytics/AnalyticsWrapper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    MuiFormControlRoot: {
      display: 'flex',
      '& label': {
        fontSize: 12
      }
    },
    MuiButtonLabel: {
      fontSize: 15
    },
    addToCartButton: {
      '&.disabled': {
        opacity: 0.5,
        cursor: 'not-allowed'
      },
      marginTop: 10
    },
    captionTypography: {
      display: 'block'
    },
    buttonPriceList: _defineProperty({
      textTransform: 'none',
      position: 'absolute',
      bottom: 90,
      fontSize: 15,
      right: 200,
      color: theme.palette.primary.main
    }, theme.breakpoints.down('xs'), {
      left: 15,
      whiteSpace: 'nowrap'
    })
  };
};
var AddToBasket = /*#__PURE__*/function (_React$Component) {
  _inherits(AddToBasket, _React$Component);
  var _super = _createSuper(AddToBasket);
  function AddToBasket() {
    _classCallCheck(this, AddToBasket);
    return _super.apply(this, arguments);
  }
  _createClass(AddToBasket, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        amount = _this$props.amount,
        disabled = _this$props.disabled,
        onPress = _this$props.onPress,
        buttonLabel = _this$props.buttonLabel,
        noteLabel = _this$props.noteLabel,
        classes = _this$props.classes,
        handleChange = _this$props.handleChange,
        note = _this$props.note,
        hidePrices = _this$props.hidePrices,
        totalPrice = _this$props.totalPrice,
        taxNote = _this$props.taxNote,
        showPriceList = _this$props.showPriceList,
        priceListLabel = _this$props.priceListLabel,
        priceListClick = _this$props.priceListClick,
        showCallToAction = _this$props.showCallToAction;
      var disabledClassName = disabled ? 'disabled' : '';
      var className = [disabledClassName].join(' ');
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        style: {
          marginBottom: 10
        }
      }), amount > 0 && !hidePrices && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showPriceList && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: priceListClick,
        className: classes.buttonPriceList
      }, priceListLabel), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h5",
        align: "right",
        classes: {
          h5: classes.MuiTypographyRoot
        }
      }, /*#__PURE__*/_react["default"].createElement("b", null, totalPrice)), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "caption",
        classes: {
          caption: classes.captionTypography
        },
        gutterBottom: true,
        align: "right"
      }, /*#__PURE__*/_react["default"].createElement("i", null, taxNote))), note && /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: noteLabel,
        multiline: true,
        rows: "3",
        rowsMax: "8",
        value: note,
        onChange: handleChange,
        margin: "normal",
        variant: "outlined",
        classes: {
          root: classes.MuiFormControlRoot
        }
      }), showCallToAction && /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "selected_amounts"
      }, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        variant: "contained",
        size: "large",
        className: className + ' ' + classes.MuiButtonLabel + ' ' + classes.addToCartButton,
        onClick: disabled ? null : onPress,
        fullWidth: true
      }, buttonLabel)));
    }
  }]);
  return AddToBasket;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'AddToBasket'
})(AddToBasket);